import React, { useState, useEffect } from 'react';

import RightModal from '../../../components/Modals/RightModal';
import MobileInput from '../../../components/InputGroup/MobileInput';
import { ReactComponent as CloseIcon } from '../../../assets/icons/close.svg';
import InputText from '../../../components/InputGroup/InputText';
import InputSelect from '../../../components/InputGroup/InputSelect';
import DateTimePicker from '../../../components/InputGroup/DateTime';
import { ReactComponent as LocationIcon } from '../../../assets/icons/location.svg';
import CenterModal from '../../../components/Modals/center-modal';
import { getProjects } from '../../../services/private/company.service';
import { insert, reSchedule, rescheduleSiteVisit } from '../../../services/private/plus.leads.service';
import InputTextarea from '../../../components/InputGroup/InputTextarea';
import { file } from 'jszip';
import { toast } from 'react-toastify';

export default function SitevisitReScheduleModal({
    show,
    closeModal,
    handleGetLeads,
    selectedLead,
    userProfile,
    users
}) {

    const [name, setName] = useState('');
    const [mobile, setMobile] = useState('');
    const [project, setProjects] = useState([]);
    const [scheduleDate, setScheduleDate] = useState('');
    const [type, setType] = useState('onsite');
    const [commnets, setComments] = useState('');
    const [projectList, setProjectList] = useState([])
    const [error, setError] = useState('');
    const [assignedTo, setAssignedTo] = useState('');

    useEffect(() => {
        if (Object.keys(selectedLead).length > 0 && projectList.length) {
            setName(selectedLead?.customer_name || '');
            setMobile(selectedLead?.customer_mobile || '');
            if (selectedLead?.site_visits?.length > 0) {
                const svProjects = []
                selectedLead?.site_visits.forEach(i => (
                    svProjects.push({
                        label: i.project_name,
                        value: i.project_id
                    })
                ))
                setProjects(svProjects)
            }
            if (selectedLead?.site_visits[0]?.assigned_to) {
                const assignedUser = users.find(i => i.label === selectedLead?.site_visits[0]?.assigned_to);
                setAssignedTo(assignedUser)
            }
        }
    }, [selectedLead, projectList]);

    const getAllProjects = async () => {

        await getProjects({}, '').then((res) => {
            if (res.status === 200) {
                let projects = res.data.data.map(i => ({ ...i, label: i.name, value: i.uuid }));
                setProjectList(projects)
            }
        }).catch((err) => {
            console.log("Something went wrong", err);
        })
    }

    useEffect(() => {
        getAllProjects()
    }, []);

    const handleSubmit = async () => {
        if (!scheduleDate || !type) {
            setError(true);
            return;
        } else {
            setError(false)
        }

        const payload = {
            reschedule_date: scheduleDate,
            sv_type: type,
            remarks: commnets,
            broker_id: assignedTo?.value || null
        }

        console.log(payload, 'payload')
        // const res = await reSchedule(selectedLead?.site_visits[0]?.uuid, payload);
        const res = await rescheduleSiteVisit(selectedLead?.site_visits[0]?.uuid, payload);
        if (res.data.status === 200) {
            console.log(res.data.message);
            // toast.success(res.data.message);
            toast.success('Site visit re-scheduled')
            handleGetLeads();
            closeModal();
        }
    }

    return (
        <CenterModal show={show} closeModal={closeModal} modalClass='!w-[560px]  [&>*]:!border-0 [&>*]:!rounded-xl [&>*]:!overflow-hidden'>
            <div className='!p-6'>
                <div className={`d-flex align-items-center justify-content-between`}>
                    {/* <h2 className='fz18 black fw-po-medium mb-0 inter'>Project Added to your list</h2> */}
                    <div className='h-12 w-12 rounded-xl bg-[#684EFB1A]/10 flex items-center justify-center'>
                        <LocationIcon className=' fill-blue-900 h-12 w-12' />
                    </div>
                    <button onClick={closeModal} className='border-0 bg-tr'><CloseIcon /></button>
                </div>
                <div className='!mt-4'>
                    <h1 className='m-0 text-lg font-semibold'>Re-Schedule a Site Visit</h1>
                </div>
                <div className='grid grid-cols-2 !gap-2'>
                    <div className='col-span-2'>
                        <InputText
                            label={'Name'}
                            placeholder={'e.g. Rahul'}
                            inputclass={'!mb-0'}
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            error={error && !name ? 'Please Enter Name' : ''}
                            required={true}
                            disable={true}
                        />
                    </div>
                    <MobileInput
                        label='Mobile'
                        value={mobile}
                        onChange={(e) => setMobile(e.phone)}
                        error={(error && !mobile) ? 'Please Enter Mobile' : ''}
                        // disable={userMobile ? true : false}
                        inputclass='!h-10 !w-full !mb-0'
                        required={true}
                        disable={true}
                    />
                    <InputSelect
                        label={'Projects'}
                        value={project}
                        onChange={(value) => setProjects(value)}
                        error={(error && project.length === 0) ? 'Please Select Project' : ''}
                        options={projectList}
                        isMulti={true}
                        required={true}
                        disable={true}
                    />
                    <div className='col-span-2'>
                        {/* <label>Type of Site Visit</label> */}
                        <div>
                            <label className='mr-4'>
                                <input
                                    type='radio'
                                    name='sitevisit'
                                    value={type}
                                    checked={type === 'onsite'}
                                    onChange={() => setType('onsite')}
                                /> Onsite
                            </label>
                            <label>
                                <input
                                    type='radio'
                                    name='sitevisit'
                                    value={type}
                                    checked={type === 'video call'}
                                    onChange={() => setType('video call')}
                                /> Video Call
                            </label>
                        </div>

                        {/* {(error && !type) &&
                            <div className='invalide'>
                                <div className="input-feedback mt-8">
                                    Please Select Site visit Type
                                </div>
                            </div>
                        } */}
                    </div>
                    <div className='col-span-2'>
                        <DateTimePicker
                            label={'Sitevisit Date & Time'}
                            inputclass={'!mb-0'}
                            value={scheduleDate}
                            onValueChange={(date) => {
                                setScheduleDate(date)
                            }}
                            error={(error && !scheduleDate) ? 'Please Select Sitevisit Date & Time' : ''}
                            required={true}
                        />
                    </div>
                    {userProfile?.is_owner && <div className='col-span-2'>
                        <InputSelect
                            label={'Assigned To'}
                            value={assignedTo}
                            onChange={(value) => setAssignedTo(value)}
                            // error={(error && project.length === 0) ? 'Please Select Project' : ''}
                            options={users}
                            isMulti={false}
                            required={false}
                        />
                    </div>}
                    <div className='col-span-2'>
                        <InputTextarea
                            label={'Comments'}
                            placeholder={'Add comments'}
                            inputclass={'!mb-0'}
                            value={commnets}
                            onChange={(e) => setComments(e.target.value)}
                        />
                    </div>

                </div>
                <div className='w-full flex !gap-4 !mt-4'>
                    <button className='w-1/2 border py-2 text-black700 rounded-lg' onClick={closeModal}>Cancel</button>
                    <button
                        className='w-1/2 gradient-blue text-white py-2 rounded-lg font-medium'
                        onClick={handleSubmit}
                    >Re-Schedule Site Visit</button>

                </div>
            </div>
        </CenterModal>
    )
}